import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

import type { CommentsSummarySource } from './CommentsSummaryContent.ts';

export const FooterCommentsSummaryCombined: LoadableType<{
	contentId: string;
	contentType: string;
	shouldRefetchCommentsSummary?: boolean;
	source: CommentsSummarySource;
	spaceKey: string;
	onRefresh?: () => void;
	isInObjectSidebar?: boolean;
	showAIDisclaimer?: boolean;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-FooterCommentsSummaryCombined" */ '../src/FooterCommentsSummaryCombined.tsx'
			)
		).FooterCommentsSummaryCombinedWithErrorBoundary,
});
